import { render } from "./gallery-carousel.vue?vue&type=template&id=67322da1"
import script from "./gallery-carousel.vue?vue&type=script&lang=js"
export * from "./gallery-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__